import app from 'flarum/common/app';
import m from 'mithril';
const CODE_RE = /:([a-z0-9_]{2,32}):/gi;

/** Emotki ustawione przez administratora (atrybut forum). */
export function emotes() {
  const list = app.forum && app.forum.attribute('swpShoutboxEmotes');
  return Array.isArray(list) ? list : [];
}
export function emoteSize() {
  const n = parseInt(String(app.forum && app.forum.attribute('swpShoutboxEmoteSize') || '24'), 10);
  return isNaN(n) ? 24 : Math.min(Math.max(n, 16), 64);
}
function byCode() {
  const map = {};
  emotes().forEach(e => {
    if (e.code) map[e.code.toLowerCase()] = e;
  });
  return map;
}

/** Tekst, który wstawia kliknięcie emotki w wybieraczce. */
export function insertText(e) {
  return e.url ? ':' + e.code + ':' : e.emoji || (e.code ? ':' + e.code + ':' : '');
}

/** Podgląd emotki (obrazek albo emoji). */
export function emoteView(e, className = 'ShoutEmote') {
  const title = e.code ? ':' + e.code + ':' : e.label || '';
  if (e.url) {
    return m('img', {
      className: className + ' ' + className + '--image',
      src: e.url,
      alt: title,
      title,
      loading: 'lazy',
      draggable: false
    });
  }
  return m('span', {
    className: className + ' ' + className + '--emoji',
    title,
    role: 'img',
    'aria-label': e.label || title
  }, e.emoji);
}

/**
 * Zamienia :kod: na emotki. Zwraca listę węzłów i informację, czy wiadomość
 * składa się wyłącznie z emotek (wtedy wyświetlamy je większe).
 */
export function renderContent(text) {
  const map = byCode();
  const nodes = [];
  let last = 0;
  let count = 0;
  let leftover = '';
  text.replace(CODE_RE, (match, code, offset) => {
    const e = map[code.toLowerCase()];
    if (!e) return match;
    const before = text.slice(last, offset);
    if (before) {
      nodes.push(before);
      leftover += before;
    }
    nodes.push(emoteView(e));
    count++;
    last = offset + match.length;
    return match;
  });
  const rest = text.slice(last);
  if (rest) {
    nodes.push(rest);
    leftover += rest;
  }

  // Same zwykłe emoji (bez liter i cyfr) też liczą się jako „tylko emotki”.
  const stripped = leftover.replace(/\s+/g, '');
  const pureEmoji = stripped !== '' && /^[\p{Extended_Pictographic}\u200d\ufe0f\u{1F3FB}-\u{1F3FF}]+$/u.test(stripped);
  const emojiCount = pureEmoji ? Array.from(stripped.replace(/[\u200d\ufe0f]/g, '')).length : 0;
  const total = count + emojiCount;
  const onlyEmotes = total > 0 && total <= 6 && (stripped === '' || pureEmoji);
  return {
    nodes,
    onlyEmotes
  };
}
flarum.reg.add('swtorpolska-shoutbox', 'common/emotes', { emotes: emotes,emoteSize: emoteSize,insertText: insertText,emoteView: emoteView,renderContent: renderContent, });